import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { History, ChevronDown, ChevronRight, Lock } from "lucide-react";
import { MilestonesTab } from "@/pages/people/MilestonesTab";
import { toast } from "sonner";

const PROGRAM = { retail: "Retail", retail_traditional: "Retail Traditional", retail_acquisition: "Retail Acquisition", associate: "Associate", protege: "Protégé", agency_producer: "Agency Producer" };
const fmt = (d) => (d ? new Date(d).toLocaleDateString() : "—");

// Read-only Candidate Program History: the original enrollments, requirement statuses, evidence and audit trail.
export function ProgramHistoryPanel({ personId, items: initial }) {
  const [items, setItems] = useState(initial || null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    if (initial) return;
    api.get(`/programs/enrollment-history/${personId}`).then((r) => setItems(r.data.history || [])).catch((e) => { toast.error(apiError(e)); setItems([]); });
  }, [personId, initial]);
  if (!items) return null;
  return (
    <div className="space-y-3" data-testid="program-history-panel">
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <p className="font-semibold text-slate-900 flex items-center gap-2"><History className="w-4 h-4 text-brand" />Candidate Program History</p>
        <p className="text-sm text-slate-500 mt-1 flex items-center gap-1.5"><Lock className="w-3.5 h-3.5" />Read-only record of earlier candidate programs. Requirement statuses, dates, documents and audit history are kept exactly as they were. Unfinished items stay as they were and aren't marked complete.</p>
      </div>
      {items.length === 0 && <p className="text-sm text-slate-400" data-testid="program-history-empty">No earlier program enrollments.</p>}
      {items.map((e) => (
        <div key={e.id} className="rounded-xl border border-slate-200 bg-white" data-testid={`program-history-${e.id}`}>
          <button onClick={() => setOpen(open === e.id ? null : e.id)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left" data-testid={`program-history-toggle-${e.id}`}>
            <span>
              <span className="font-medium text-slate-800">{PROGRAM[e.program] || e.program}{e.program_subtype ? ` · ${e.program_subtype}` : ""}{e.version_label ? ` (${e.version_label})` : ""}</span>
              <span className="block text-xs text-slate-500">Started {fmt(e.start_date || e.created_at)} · {e.requirements_complete}/{e.requirements_total} requirements complete{e.career_date ? ` · Career ${fmt(e.career_date)}` : ""}{e.fta_date ? ` · FTA ${fmt(e.fta_date)}` : ""}</span>
            </span>
            {open === e.id ? <ChevronDown className="w-4 h-4 text-slate-400" /> : <ChevronRight className="w-4 h-4 text-slate-400" />}
          </button>
          {open === e.id && <div className="border-t border-slate-100 p-4"><MilestonesTab personId={personId} canManage={false} enrollmentId={e.id} /></div>}
        </div>
      ))}
    </div>
  );
}
